import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS, PERMISSIONS } from 'src/constants';
import {
  ACTIVITY_AREA,
  markActivitySeen,
  shouldMarkListSeen,
} from 'src/actions/activityActions';
import { getAccountInfo } from 'src/actions/accountActions';
import { addNotification } from 'src/actions/notificationActions';

export const SET_LOADING = '@group-details/set-loading';
export const SET_CURRENT_NAVIGATION_TAB = '@group-details/set-current-navigation-tab';

export const GET_GROUP = '@group-details/get-group';
export const GET_GROUP_SUCCESS = '@group-details/get-group-success';
export const GET_GROUP_ERROR = '@group-details/get-group-error';

export const GET_GROUP_USAGES = '@group-details/get-group-usages';
export const GET_GROUP_USAGES_SUCCESS = '@group-details/get-group-usages-success';
export const GET_GROUP_USAGES_ERROR = '@group-details/get-group-usages-error';

export const DELETE_GROUP = '@group-details/del-group';
export const DELETE_GROUP_CONFIRM_DELETION = '@group-details/del-group-confirm-deletion';
export const DELETE_GROUP_SUCCESS = '@group-details/del-group-success';
export const DELETE_GROUP_ERROR = '@group-details/del-group-error';
export const CLEAR_GROUP_WAS_DELETED = '@group-details/clear-group-was-deleted';

export const UPDATE_GROUP = '@group-details/update-group';
export const UPDATE_GROUP_SUCCESS = '@group-details/update-group-success';
export const UPDATE_GROUP_ERROR = '@group-details/update-group-error';

export const CREATE_GROUP = '@group-details/create-group';
export const CREATE_GROUP_SUCCESS = '@group-details/create-group-success';
export const CREATE_GROUP_ERROR = '@group-details/create-group-error';

export const UPDATE_GROUP_MEMBER_MESSAGING = '@group-details/update-group-member-messaging';
export const UPDATE_GROUP_MEMBER_MESSAGING_SUCCESS = '@group-details/update-group-member-messaging-success';
export const UPDATE_GROUP_MEMBER_MESSAGING_ERROR = '@group-details/update-group-member-messaging-error';

export const GET_GROUP_SOURCES = '@group-details/get-group-sources';
export const GET_GROUP_SOURCES_SUCCESS = '@group-details/get-group-sources-success';
export const GET_GROUP_SOURCES_ERROR = '@group-details/get-group-sources-error';

export const SET_GROUP_DETAILS_TAB = '@group-details/set-group-details-tab';

export const SET_FORM_CREATE_UPDATE_GROUP = '@group-details/set-form-create-update-group';

export const SET_FORM_UPDATE_GROUP_MEMBER_MESSAGING = '@group-details/set-form-update-group-member-messaging';

export const SET_VALUES_WELCOME_MESSAGE = '@group-details/set-values-welcome-message';

export const SET_VALUES_FORM_ADD_GROUP_MEMBER = '@group-details/set-values-form-add-group-member';

export const SEND_ADD_GROUP_MEMBER = '@group-details/send-add-group-member';
export const SEND_ADD_GROUP_MEMBER_SUCCESS = '@group-details/send-add-group-member-success';
export const SEND_ADD_GROUP_MEMBER_ERROR = '@group-details/send-add-group-member-error';

export const SEND_REMOVE_GROUP_MEMBERS = '@group-details/send-remove-group-members';
export const SEND_REMOVE_GROUP_MEMBERS_SUCCESS = '@group-details/send-remove-group-members-success';
export const SEND_REMOVE_GROUP_MEMBERS_ERROR = '@group-details/send-remove-group-members-error';

export const GET_CONTACTS_LIST = '@group-details/get-contacts-list';
export const GET_CONTACTS_LIST_SUCCESS = '@group-details/get-contacts-list-success';
export const GET_CONTACTS_LIST_ERROR = '@group-details/get-contacts-list-error';

export const SET_GROUP_MEMBERS = '@group-details/set-group-members';
export const GET_GROUP_MEMBERS = '@group-details/get-group-members';
export const GET_GROUP_MEMBERS_SUCCESS = '@group-details/get-group-members-success';
export const GET_GROUP_MEMBERS_ERROR = '@group-details/get-group-members-error';

export const SET_GROUP_MEMBERS_QUERY = '@group-details/set-group-members-query';

export const GET_FOLLOW_UP_MESSAGES = '@group-details/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@group-details/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@group-details/get-follow-up-messages-error';

export const REPLACE_SYSTEM_GEN_MESSAGE = '@group-details/replace-system-gen-message';
export const REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS = '@group-details/replace-system-gen-message-success';
export const REPLACE_SYSTEM_GEN_MESSAGE_ERROR = '@group-details/replace-system-gen-message-error';

// export const SEND_TEXT_MESSAGE = '@group-details/send-text-message';
// export const SEND_TEXT_MESSAGE_SUCCESS = '@group-details/send-text-message-success';
// export const SEND_TEXT_MESSAGE_ERROR = '@group-details/send-text-message-error';

export const SET_SELECTED_GROUP_MEMBERS = '@group-details/set-selected-group-members';
export const SET_SELECTED_CONTACT_IDS = '@group-details/set-selected-contact-ids';

// export const SET_VALUES_FORM_SEND_TEXT = '@group-details/set-values-form-send-text';

export const SET_VISIBLE_MODAL_FORM_NUMBER = '@group-details/set-visible-modal-form-number';

export const SET_VALUES_FORM_ADD_CATEGORY = '@group-details/set-values-form-add-category';

export const SEND_ADD_CATEGORY = '@group-details/send-add-category';
export const SEND_ADD_CATEGORY_SUCCESS = '@group-details/send-add-category-success';
export const SEND_ADD_CATEGORY_ERROR = '@group-details/send-add-category-error';

export const SET_UPDATE_UPDATE_GROUP_TYPE_COMPONENTS = '@group-details/set-update-update-group-type-components';

export const MODIFY_MEMBERS = '@group-details/modify-members';
export const MODIFY_MEMBERS_SUCCESS = '@group-details/modify-members-success';
export const MODIFY_MEMBERS_ERROR = '@group-details/modify-members-error';

export const GET_CUSTOM_FIELDS = '@group-details/get-custom-fields';
export const GET_CUSTOM_FIELDS_SUCCESS = '@group-details/get-custom-fields-success';
export const GET_CUSTOM_FIELDS_ERROR = '@group-details/get-custom-fields-error';

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading
});

export const setCurrentNavigationTab = (tabName) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tabName
});

export const getGroup = (groupId) => async (dispatch) => {
  dispatch({
    type: GET_GROUP,
  });
  try {
    const response = await axios.get(`/api/groups/${groupId}`);
    dispatch({
      type: GET_GROUP_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_ERROR,
    });
  }
};

export const getGroupUsages = (groupId) => async (dispatch) => {
  dispatch({
    type: GET_GROUP_USAGES,
  });
  try {
    const response = await axios.get(`/api/groups/${groupId}/usages`);
    dispatch({
      type: GET_GROUP_USAGES_SUCCESS,
      payload: {
        ...response?.data || {},
        groupId: helpers.transform.toInt10(groupId),
      }
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_USAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_USAGES_ERROR,
    });
  }
};

export const deleteGroup = (
  groupId,
  isFirstDeleteRequest = false,
  isDeleteConfirmed = false,
  doWhenTry = () => { },
  doWhenCatch = () => { },
  doWhenConfirm = () => { },
) => async (dispatch) => {
  dispatch({
    type: DELETE_GROUP,
  });
  try {
    const response = await axios.delete(
      `/api/groups/${groupId}`,
      {
        data: {
          isDeleteConfirmed,
        }
      }
    );
    const payload = response?.data?.message;
    dispatch({
      type: DELETE_GROUP_SUCCESS,
      payload,
    });
    if (!payload) {
      dispatch(getGroup(groupId));
      dispatch(addNotification(DELETE_GROUP_ERROR, `Can not delete group ${groupId}`, NOTIFICATION_STATUS.ERROR));
      return;
    }
    dispatch(getAccountInfo());
    dispatch(addNotification(DELETE_GROUP_SUCCESS, payload || 'Group was deleted', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
      isDeletionConfirmationRequired,
    } = e?.response?.data || {};

    if (isFirstDeleteRequest && isDeletionConfirmationRequired) {
      dispatch({
        type: DELETE_GROUP_CONFIRM_DELETION,
        payload: {
          isDeletionConfirmationRequired,
          groupId: helpers.transform.toInt10(groupId),
        },
      });
      if (doWhenConfirm) {
        doWhenConfirm();
      }
      return;
    }

    dispatch(addNotification(DELETE_GROUP_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch(getGroup(groupId));
    dispatch({
      type: DELETE_GROUP_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch();
    }
  }
};

export const clearGroupWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GROUP_WAS_DELETED,
  });
};

export const updateGroup = (groupId, groupChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UPDATE_GROUP,
    });
    const {
      updateGroupTypeComponents,
    } = getState()?.groupDetails || {};

    const response = await axios.put(`/api/groups/${groupId}`, {
      ...groupChanges,
      updateGroupTypeComponents,
    });
    const {
      id,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(UPDATE_GROUP_ERROR, 'Can not update group', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_GROUP_ERROR,
      });
      return;
    }

    dispatch(getAccountInfo());
    await dispatch(getGroup(groupId));
    dispatch(addNotification(UPDATE_GROUP_SUCCESS, 'The group has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_GROUP_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(UPDATE_GROUP_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_GROUP_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const createGroup = (groupChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_GROUP,
    });
    const response = await axios.post('/api/groups/create', groupChanges,);
    const {
      id,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(CREATE_GROUP_ERROR, 'Can not create group', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CREATE_GROUP_ERROR,
      });
      return;
    }

    dispatch(addNotification(CREATE_GROUP_SUCCESS, 'Your group has been successfully created', NOTIFICATION_STATUS.SUCCESS));

    dispatch({
      type: CREATE_GROUP_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(CREATE_GROUP_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CREATE_GROUP_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateGroupMemberMessaging = (groupContactMessagingDetails, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_GROUP_MEMBER_MESSAGING,
    });
    const response = await axios.put('/api/groups/groupContactMessaging', groupContactMessagingDetails);
    const {
      success,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(UPDATE_GROUP_MEMBER_MESSAGING_ERROR, 'Can not update group', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_GROUP_MEMBER_MESSAGING_ERROR,
      });
      return;
    }

    dispatch(addNotification(UPDATE_GROUP_MEMBER_MESSAGING_SUCCESS, 'Join Actions has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_GROUP_MEMBER_MESSAGING_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
    } = e?.response?.data || {};

    const { message: errorMessage } = error || {};
    dispatch(addNotification(UPDATE_GROUP_MEMBER_MESSAGING_ERROR, errorMessage || 'Could not update the message, categories, or groups.', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_GROUP_MEMBER_MESSAGING_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setGroupDetailsTab = (tabName) => async (dispatch) => {
  dispatch({
    type: SET_GROUP_DETAILS_TAB,
    payload: tabName
  });
};

export const setFormCreateUpdateGroup = (payload) => ({
  type: SET_FORM_CREATE_UPDATE_GROUP,
  payload
});

// CON-1658 — keepSelection: opt-in for the refetch that follows a bulk
// modify, so the user can run another action on the same contacts. Every
// other caller leaves it false and keeps the clear-on-load behavior.
export const getGroupMembers = ({ keepSelection = false } = {}) => async (dispatch, getState) => {
  dispatch({
    type: GET_GROUP_MEMBERS,
  });

  const { id: groupId } = getState()?.groupDetails?.group || {};
  const {
    sort,
    search = '',
    filters = {},
    page = 1,
    pageSize = 50,
  } = getState()?.groupDetails?.query || {};

  const {
    joinedGroupDateFrom,
    joinedGroupDateTo,
    joiningList,
    hostingList,
    sourceList,
    activeSmartFields,
    inactiveSmartFields,
  } = filters || {};

  const params = {
    sort,
    search,
    filters: {
      joinedGroupDateFrom,
      joinedGroupDateTo,
      joiningList,
      hostingList,
      sourceList,
      // CON-1529: the FilterForm writes these into query.filters; this
      // action rebuilds params.filters from an explicit key list, so they
      // must be forwarded here or the backend never receives the SF
      // filters (chips show but the list is unfiltered).
      activeSmartFields,
      inactiveSmartFields,
    },
    screen: 'group',
    page,
    pageSize,
  };

  // CON-2026 — activity badges (P1d). Holders ask which members on this page
  // are new; the Contacts tab is the only caller of this action, so opening
  // it (and every reload of it) marks the group seen, but only when every
  // unseen member is on the page shown. Everyone else sends what they did.
  const hasActivityBadges = helpers.permissions.doesUserHavePermission(
    PERMISSIONS.PERMISSIONS_SYSTEM_CODE.ACTIVITY_BADGES,
    getState()?.account?.user?.userRole?.permissions || [],
  );
  if (hasActivityBadges) {
    params.withActivity = true;
  }

  try {
    const response = await axios.post(`/api/groups/${groupId}/members`, { params });
    dispatch({
      type: GET_GROUP_MEMBERS_SUCCESS,
      payload: { ...(response?.data || {}), keepSelection, groupId }
    });
    const activity = response?.data?.activity;
    if (shouldMarkListSeen(activity)) {
      dispatch(markActivitySeen({
        area: ACTIVITY_AREA.GROUP_MEMBERS,
        entityId: groupId,
        seenThrough: activity.serverNow,
      }));
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_MEMBERS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_MEMBERS_ERROR,
    });
  }
};

export const setGroupMembers = (groupMembers) => ({
  type: SET_GROUP_MEMBERS,
  payload: groupMembers,
});

export const setGroupMembersQuery = (query) => ({
  type: SET_GROUP_MEMBERS_QUERY,
  payload: query
});

export const setSelectedGroupMembers = (selectedGroupMembers) => ({
  type: SET_SELECTED_GROUP_MEMBERS,
  payload: selectedGroupMembers
});

export const getGroupSourcesList = () => async (dispatch) => {
  dispatch({
    type: GET_GROUP_SOURCES,
  });

  try {
    const response = await axios.get('/api/groups/group-sources-list');
    dispatch({
      type: GET_GROUP_SOURCES_SUCCESS,
      payload: response?.data || []
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_SOURCES_ERROR, helpers.transform.toString(message || error?.message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_SOURCES_ERROR,
    });
  }
};

export const setSelectedContactIds = (selectedContacts) => ({
  type: SET_SELECTED_CONTACT_IDS,
  payload: selectedContacts
});

export const setVisibleModalFormNumber = (modalNumber) => ({
  type: SET_VISIBLE_MODAL_FORM_NUMBER,
  payload: modalNumber
});

// export const setValuesFormSendText = (values) => ({
//   type: SET_VALUES_FORM_SEND_TEXT,
//   payload: values
// });

// export const sendTextMessage = (sendMessage, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
//   try {
//     dispatch({
//       type: SEND_TEXT_MESSAGE,
//     });
//     const response = await axios.put('/api/contacts/sendmessage', { sendMessage });
//     const { success } = response?.data || {};

//     if (!success) {
//       dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
//       dispatch({
//         type: SEND_TEXT_MESSAGE_ERROR,
//       });
//       return;
//     }

//     dispatch(addNotification(SEND_TEXT_MESSAGE_SUCCESS, 'Your text has been scheduled to send.', NOTIFICATION_STATUS.SUCCESS));
//     dispatch({
//       type: SEND_TEXT_MESSAGE_SUCCESS,
//     });

//     if (doWhenTry) {
//       doWhenTry();
//     }
//   } catch (e) {
//     const {
//       message,
//       error,
//     } = e?.response?.data || {};
//     const { message: errorMessage } = error || {};
//     dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
//     dispatch({
//       type: SEND_TEXT_MESSAGE_ERROR,
//     });

//     if (doWhenCatch) {
//       doWhenCatch(e);
//     }
//   }
// };

export const setValuesFormAddCategory = (values) => ({
  type: SET_VALUES_FORM_ADD_CATEGORY,
  payload: values
});

export const sendAddCategory = (addTagCampaign, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_CATEGORY,
    });
    const response = await axios.put('/api/contacts/addtagcampaign', { addTagCampaign });
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_ADD_CATEGORY_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_CATEGORY_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_CATEGORY_SUCCESS, 'The category has been added.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_CATEGORY_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_ADD_CATEGORY_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setValuesFormAddGroupMember = (values) => ({
  type: SET_VALUES_FORM_ADD_GROUP_MEMBER,
  payload: values
});

export const sendAddGroupMember = (groupId, addGroupMember, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_ADD_GROUP_MEMBER,
    });
    const { contactIds } = addGroupMember || {};
    const isMultipleContacts = contactIds?.length > 1;

    const response = await axios.post(`/api/groups/${groupId}/members/add`, addGroupMember);
    const { message } = response?.data || {};

    if (!message) {
      dispatch(addNotification(SEND_ADD_GROUP_MEMBER_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_ADD_GROUP_MEMBER_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_ADD_GROUP_MEMBER_SUCCESS, isMultipleContacts ? 'The contacts have been added to group.' : 'The contact has been added to group.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_ADD_GROUP_MEMBER_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error: errorMessage,
    } = e?.response?.data || {};
    dispatch(addNotification(SEND_ADD_GROUP_MEMBER_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_ADD_GROUP_MEMBER_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const sendRemoveGroupMembers = (groupId, selectedGroupMembers, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_REMOVE_GROUP_MEMBERS,
    });
    const response = await axios.delete(`/api/groups/${groupId}/members`, {
      data: {
        memberIds: selectedGroupMembers
      }
    });
    const { message } = response?.data || {};

    if (!message) {
      dispatch(addNotification(SEND_REMOVE_GROUP_MEMBERS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_REMOVE_GROUP_MEMBERS_ERROR,
      });
      return;
    }

    const removeSuccessMessage = selectedGroupMembers.length > 1 ? 'The contacts have been removed' : 'The contact has been removed';

    dispatch(addNotification(SEND_REMOVE_GROUP_MEMBERS_SUCCESS, message || removeSuccessMessage, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_REMOVE_GROUP_MEMBERS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_REMOVE_GROUP_MEMBERS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_REMOVE_GROUP_MEMBERS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getUserContacts = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CONTACTS_LIST,
    });
    const response = await axios.get('/api/contacts/contactlist');
    const { error, message } = response?.data || {};
    if (error || message) {
      dispatch(addNotification(GET_CONTACTS_LIST_ERROR, error || message, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_CONTACTS_LIST_ERROR,
      });
      return;
    }
    dispatch({
      type: GET_CONTACTS_LIST_SUCCESS,
      payload: response?.data?.contacts || [],
    });
  } catch (e) {
    const { error, message } = e?.response?.data || {};
    dispatch(addNotification(GET_CONTACTS_LIST_ERROR, error || message || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CONTACTS_LIST_ERROR,
    });
  }
};

// CON-1621 — contexts limits the picker to template scopes that can
// actually resolve on this surface's send path. Omitted means the server
// returns contact scope only (fail closed).
export const getFollowUpMessages = (contexts = null) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag', contexts ? { contexts } : {}) || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj,
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
      payload: data?.message,
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
    });
  }
};

export const setFormGroupMemberMessaging = (payload) => ({
  type: SET_FORM_UPDATE_GROUP_MEMBER_MESSAGING,
  payload
});

export const setValuesWelcomeMessage = (values) => ({
  type: SET_VALUES_WELCOME_MESSAGE,
  payload: values
});

export const setUpdateUpdateGroupTypeComponents = (payload) => async (dispatch) => {
  dispatch({
    type: SET_UPDATE_UPDATE_GROUP_TYPE_COMPONENTS,
    payload,
  });
};

export const modifyMembers = (groupId, membersChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: MODIFY_MEMBERS,
    });
    const response = await axios.put(`/api/groups/${groupId}/members`, { membersChanges }) || {};
    const { message } = response?.data || {};

    if (!message) {
      dispatch(addNotification(MODIFY_MEMBERS_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: MODIFY_MEMBERS_ERROR,
      });
      return;
    }

    dispatch(addNotification(MODIFY_MEMBERS_SUCCESS, 'Selected contacts have been successfully updated.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: MODIFY_MEMBERS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(MODIFY_MEMBERS_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: MODIFY_MEMBERS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getCustomFields = (groupId) => async (dispatch) => {
  dispatch({
    type: GET_CUSTOM_FIELDS,
  });
  try {
    const response = await axios.get(`/api/groups/${groupId}/custom-fields`);

    dispatch({
      type: GET_CUSTOM_FIELDS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CUSTOM_FIELDS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CUSTOM_FIELDS_ERROR,
    });
  }
};

export const clearCustomFields = () => ({
  type: GET_CUSTOM_FIELDS_SUCCESS,
});
